//@flow
import ReactGA from 'react-ga';

class UserAnalyticsService {
    static activePage = null;
    static pageName = null;
    static startTime = null;
    static clientId = null;

    constructor() {
        ReactGA.initialize('UA-104977587-1', { siteSpeedSampleRate: 100 });
    }

    get activePage(): string {
        return UserAnalyticsService.activePage;
    }

    setPageName(pageName: string) {
        UserAnalyticsService.pageName = pageName;
    }

    setPage(activePage: string) {
        UserAnalyticsService.activePage = activePage;
        ReactGA.set({ page: activePage });
        ReactGA.pageview(activePage);
    }

    setApiTiming(
        method: string,
        endPointIdentifier: string,
        timeTakenInMillis: number
    ) {
        ReactGA.timing({
            category: 'API Latency',
            variable: `${method} ${endPointIdentifier}`,
            value: Math.round(timeTakenInMillis),
            label: `${method} ${endPointIdentifier}`
        });
    }

    setPageLoadStartTime(startTime: number) {
        UserAnalyticsService.startTime = startTime;
    }

    setPageLoadEndTime(endTime: number, clientId: string) {
        if (UserAnalyticsService.startTime) {
            const loadTime = Math.round(
                endTime - UserAnalyticsService.startTime
            );
            ReactGA.timing({
                category: 'Page load time',
                variable: UserAnalyticsService.pageName,
                value: loadTime,
                label: clientId
            });
            UserAnalyticsService.startTime = null; // Reset startTime back to null after logging this timing
        }
    }
}

export default new UserAnalyticsService();
